<!--  专家修改 -->
<template>
  <div>
    <zlr-plane title="文书名称"
               style="margin-bottom:40px;">
      <div class="essay-content">
        <span v-for="(item,index) in essayList"
              :class="{
                active: curEssay === item.id
              }"
              :key="index"
              @click="handleSelectEssay(item)">{{item.title}}</span>
      </div>
    </zlr-plane>
    <template v-if="emEdit.length || smEdit.length">
      <zlr-plane title="SM Edit"
                 style="margin-bottom:40px;"
                 v-for="(smItem,smIndex) in smEdit"
                 :key="'sm'+smIndex+curEssay">
        <ul class="essay-round">
          <li v-for="(item,index) in smItem.expertEdit"
              :key="index">
            <zlr-card-simple :title="'专家修改'+ (index+1 < 10 ? `0${index+1}` : index+1)"
                             :name="item.expertName"
                             :avatar="ZlrLogo"
                             :circleSign="item | filterColor">
              <a class="primary"
                 style="position:relative;z-index:101"
                 @click="handleDetail(item, index)">查看详情</a>
              <a class="orange"
                 @click="handleFeedback(item)"
                 v-if="!item.menteeEditDTO && !item.uploadStatus">修改反馈</a>
            </zlr-card-simple>
          </li>
          <!-- <li>
          <zlr-card-simple title="专家修改 1"
                           name="郭小萌"
                           :avatar="MentorAvatar"
                           circleSign="orange">
            <a class="primary"
               @click="handleDetail">查看详情</a>

          </zlr-card-simple>
        </li> -->
        </ul>
      </zlr-plane>
      <zlr-plane title="EM Edit"
                 style="margin-bottom:40px;"
                 v-for="(emItem,emIndex) in emEdit"
                 :key="'em'+emIndex+curEssay">
        <ul class="essay-round">
          <li v-for="(item,index) in emItem.expertEdit"
              :key="index">
            <zlr-card-simple :title="'专家修改'+ (index+1 < 10 ? `0${index+1}` : index+1)"
                             :name="item.expertName"
                             :avatar="ZlrLogo"
                             :circleSign="item | filterColor">
              <a class="primary"
                 style="position:relative;z-index:101"
                 @click="handleDetail(item, index)">查看详情</a>
              <a class="orange"
                 @click="handleFeedback(item)"
                 v-if="!item.menteeEditDTO && !item.uploadStatus">修改反馈</a>
            </zlr-card-simple>
          </li>
          <!-- <li>
          <zlr-card-simple title="专家修改 1"
                           name="郭小萌"
                           :avatar="MentorAvatar"
                           circleSign="orange">
            <a class="primary"
               @click="handleDetail">查看详情</a>
            <a class="orange"
               @click="handleFeedback">修改反馈</a>
          </zlr-card-simple>
        </li> -->
        </ul>
      </zlr-plane>
    </template>
    <zlr-empty v-else></zlr-empty>
    <!-- 修改详情 -->
    <modify-detail ref="modifyDetail"></modify-detail>
    <!-- 修改反馈 -->
    <modify-feedback ref="modifyFeedback"
                     @on-success="getExpertEssays"></modify-feedback>
  </div>
</template>

<script>
import ModifyDetail from './components/modify-detail'
import ZlrPlane from '@/components/panel'
import ZlrCardSimple from '_c/card-simple/card-simple'
import ModifyFeedback from './components/modify-feedback'
import ZlrEmpty from '_c/empty/empty'
// images
import ZlrLogo from '@/assets/msp.svg'
// API
import { getMaterialSingleProject } from '@/api/material'
import { getExpertEssays } from '@/api/expert'
export default {
  name: '',
  components: {
    ZlrPlane,
    ZlrCardSimple,
    ModifyDetail,
    ModifyFeedback,
    ZlrEmpty
  },
  data () {
    return {
      ZlrLogo,
      programId: this.$route.params.id,
      essayList: [],
      curEssay: '',
      emEdit: [],
      smEdit: []
    }
  },
  computed: {},
  mounted () {
    this.getMaterialSingleProject()
  },
  methods: {
    getMaterialSingleProject () {
      getMaterialSingleProject({
        id: this.programId
      }).then(res => {
        let essayList = res.data.model.progress.bills
        this.essayList = essayList
        if (essayList.length) {
          this.curEssay = essayList[0].id
          this.getExpertEssays()
        }
      })
    },
    getExpertEssays () {
      getExpertEssays({
        billId: this.curEssay
      }).then(res => {
        let data = (res.data && res.data.model) || {}
        let emEdit = data.emEdit || []
        let smEdit = data.smEdit || []
        this.emEdit = emEdit.filter(item => item.expertEdit && item.expertEdit.length) || []
        this.smEdit = smEdit.filter(item => item.expertEdit && item.expertEdit.length) || []
      }).catch(error => {
        this.$zlr_message(error.message, 'error')
      })
    },
    handleDetail (item, index) {
      this.$refs['modifyDetail'].show(item, index + 1)
    },
    handleFeedback (item) {
      this.$refs['modifyFeedback'].show(item)
    },
    handleSelectEssay ({ id }) {
      if (this.curEssay === id) return false
      this.curEssay = id
      this.getExpertEssays()
    }
  },
  filters: {
    filterColor (item) {
      if (item.menteeEditDTO || item.uploadStatus) return 'green'
      return 'orange'
    }
  }
}
</script>
<style lang='less' scoped>
.essay-content {
  span {
    display: inline-block;
    height: 48px;
    line-height: 48px;
    padding: 0 26px;
    border-radius: 4px;
    font-size: 14px;
    margin-right: 40px;
    border: 1px solid rgba(0, 0, 0, 0.25);
    box-sizing: border-box;
    cursor: pointer;
    &.active {
      background: @c-cyan3-blue4;
      color: #fff;
      border: none;
    }
  }
}
.essay-round {
  > li {
    display: inline-block;
    margin-right: 80px;
  }
}
</style>
